import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  DataTable,
  Page,
  Filters,
  Image,
  ChoiceList,
  Loading,
  Card,
  Text,
  Spinner,
  Tag,
  Button,
  Modal,
  Badge,
  Toast,
  TextContainer,
  TextField,
  FormLayout,
  Select,
  Icon,
  Layout,
  ButtonGroup,
  Tooltip,
  InlineGrid,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import emptyListImage from "../../../Assets/Images/emptyList.svg";
import Pagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import "bootstrap/dist/css/bootstrap.css";

import {
  ExportIcon,
  ProductsMajor,
  SendIcon,
  StarFilledIcon,
  StarIcon,
  CategoriesIcon,
  AlertCircleIcon,
} from "@shopify/polaris-icons";
import SlidingPane from "react-sliding-pane";
import EllipsisText from "react-ellipsis-text";

const Contacts = () => {
  const navigate = useNavigate();

  const [isSaving, setIsSaving] = useState(false);
  const refBoolPage = useRef(true);
  const refId = useRef(null);
  const [popupActive, setPopupActive] = useState(false);
  const format = "YYYY-MM-DD HH:mm:ss";
  const perPage = 200;
  const [isLoading, setIsLoading] = useState(true);
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [sortState, setSortState] = useState("-id");
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  const handleSort = (index, direction) => {
    console.log("index=", index, direction);
    if (index === 2) {
      direction === "descending"
        ? setSelectedSorting("-impressions")
        : setSelectedSorting("impressions");
    }
    if (index === 10) {
      direction === "descending"
        ? setSelectedSorting("-created_at")
        : setSelectedSorting("created_at");
    }
  };
  // sortState === "id" ? setSortState("-id") : setSortState("id");
  const [ts, setTs] = useState("");
  const clickedContact = useRef("");

  const handleRowClick = (param) => {
    // navigate(`/admin/crm/contacts/${id}`);
    console.log(param);
    param.note ? setNoteValue(param.note) : setNoteValue("");
    clickedContact.current = param;

    setSliderOpen(true);
    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "hidden";
    }
    param.is_favorite
      ? setFavoritesButtonText("Remove from Favorites")
      : setFavoritesButtonText("Add to Favorites");
    setSelectedUserCategory(String(param.category_id));
    setSelectedUserStatus(String(param.status.id));
  };

  function handleFiltersQueryChange(queryValue) {
    refBoolPage.current = false;
    setQueryValue(queryValue);
  }
  function handleAvailabilityChange(availability) {
    setAvailability(availability);
  }
  const handleAvailabilityRemove = useCallback(() => setAvailability(""), []);
  const handleQueryValueRemove = useCallback(() => setQueryValue(""), []);
  const handleFiltersClearAll = useCallback(() => {
    handleAvailabilityRemove();
    handleQueryValueRemove();
  }, [handleAvailabilityRemove, handleQueryValueRemove]);

  const filters = [
    // {
    //   key: "availability",
    //   label: "Filter by",
    //   filter: (
    //     <ChoiceList
    //       title="Filter by"
    //       titleHidden
    //       choices={[
    //         { label: "Name", value: "name" },
    //         { label: "Email", value: "email" },
    //         // { label: "Category", value: "category" },
    //         // { label: "Campaign", value: "internalCampaign" },
    //         // { label: "Date range", value: "created_between" },
    //       ]}
    //       selected={availability || []}
    //       onChange={handleAvailabilityChange}
    //     />
    //   ),
    //   shortcut: true,
    // },
  ];

  const appliedFilters = [];
  if (!isEmpty(availability)) {
    const key = "availability";
    appliedFilters.push({
      key,
      label: disambiguateLabel(key, availability),
      onRemove: handleAvailabilityRemove,
    });
  }

  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <img src={emptyListImage}></img>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This contact have been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleEdit = (id) => {
    navigate(`/admin/crm/contacts/${id}`);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/crm/contacts/${refId.current}`)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleExport = () => {
    setIsExporting(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/crm/contacts/export?category_id=${
          selectedCategory !== "all" && selectedCategory !== ""
            ? selectedCategory
            : ""
        }&from_created_date=${
          startDateValue ? startDateValue : ""
        }&to_created_date=${endDateValue ? endDateValue : ""}&global_search=${
          queryValue ? queryValue : ""
        }`
      )
      .then((result) => {
        setIsExporting(false);
        setToastContent("Please check your email to find the exported sheet");
        toggleActive();
      })
      .catch((err) => console.log(err));
    // window.open(
    //   `${
    //     process.env.REACT_APP_BASE_URL
    //   }/crm/contacts/export?token=${"z5qc0gQkrwX5Vjct0enPu6WgOUY8nb67GYIVXx6b"}&category_id=${
    //     selectedCategory !== "all" && selectedCategory !== ""
    //       ? selectedCategory
    //       : ""
    //   }&from_created_date=${
    //     startDateValue ? startDateValue : ""
    //   }&to_created_date=${endDateValue ? endDateValue : ""}&global_search=${
    //     queryValue ? queryValue : ""
    //   }`
    // );
    // const windowOptions = {
    //   headers: {
    //     Authorization: `Bearer ${Cookies.get("cms-accesstoken")}`,
    //   },
    // };
    // window.open(
    //   "https://staging-dxp.creo-dev.com/admin/crm/contacts/export",
    //   windowOptions
    // );
  };

  const [startDateValue, setStartDateValue] = useState("");
  const handleChangeStartDate = useCallback(
    (newValue) => setStartDateValue(newValue),
    []
  );
  const [endDateValue, setEndDateValue] = useState("");
  const handleChangeEndDate = useCallback(
    (newValue) => setEndDateValue(newValue),
    []
  );
  const [selectedCategory, setSelectedCategory] = useState("all");
  const handleSelectChangeCategory = useCallback(
    (value) => setSelectedCategory(value),
    []
  );
  const [selectedUserCategory, setSelectedUserCategory] = useState("");

  const [selectedUserStatus, setSelectedUserStatus] = useState("");

  const optionsCategories = [
    { label: "All ", value: "all" },
    { label: "PROSPECT ", value: "1" },
    { label: "CUSTOMER ", value: "2" },
    { label: "SUPPLIER ", value: "3" },
    { label: "PARTNER  ", value: "4" },
  ];
  var randomColor = require("randomcolor");
  const [selectedSorting, setSelectedSorting] = useState("-created_at");
  const handleSelectChangeSorting = useCallback(
    (value) => setSelectedSorting(value),
    []
  );
  const optionsSorting = [
    { label: "Date: New to Old", value: "-created_at" },
    { label: "Date: Old to New", value: "created_at" },
    { label: "Name: A-Z", value: "first_name" },
    { label: "Name: Z-A", value: "-first_name" },
  ];
  const iconStarFilled = () => {
    return (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 800 800"
        style={{ enableBackground: "new 0 0 800 800" }}
        xmlSpace="preserve"
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t.st0{fill:#FCCA32;stroke:#FCCA32;stroke-width:60;stroke-miterlimit:10;}\n",
          }}
        />
        <path
          className="st0"
          d="M435,75l81.8,165.7c5.7,11.5,16.7,19.5,29.4,21.4l182.9,26.6c32,4.7,44.8,44,21.6,66.6l-132.3,129
      c-9.2,9-13.4,21.9-11.2,34.6L638.4,701c5.5,31.9-28,56.2-56.7,41.2l-163.6-86c-11.4-6-25-6-36.4,0l-163.6,86
      c-28.7,15.1-62.1-9.3-56.7-41.2l31.2-182.2c2.2-12.7-2-25.6-11.2-34.6l-132.3-129c-23.2-22.6-10.4-62,21.6-66.6l182.9-26.6
      c12.7-1.8,23.7-9.8,29.4-21.4L365,75C379.3,46,420.7,46,435,75z"
        />
      </svg>
    );
  };
  const iconStarOutlined = () => {
    return (
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 800 800"
        style={{ enableBackground: "new 0 0 800 800" }}
        xmlSpace="preserve"
      >
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html:
              "\n\t.st0{fill:none;stroke:#FCCA32;stroke-width:60;stroke-miterlimit:10;}\n",
          }}
        />
        <path
          className="st0"
          d="M435,75l81.8,165.7c5.7,11.5,16.7,19.5,29.4,21.4l182.9,26.6c32,4.7,44.8,44,21.6,66.6l-132.3,129
      c-9.2,9-13.4,21.9-11.2,34.6L638.4,701c5.5,31.9-28,56.2-56.7,41.2l-163.6-86c-11.4-6-25-6-36.4,0l-163.6,86
      c-28.7,15.1-62.1-9.3-56.7-41.2l31.2-182.2c2.2-12.7-2-25.6-11.2-34.6l-132.3-129c-23.2-22.6-10.4-62,21.6-66.6l182.9-26.6
      c12.7-1.8,23.7-9.8,29.4-21.4L365,75C379.3,46,420.7,46,435,75z"
        />
      </svg>
    );
  };
  const [categories, setCategories] = useState([
    { label: "All", value: "all" },
  ]);
  const [statuses, setStatuses] = useState([{ label: "All", value: "all" }]);
  const [isExporting, setIsExporting] = useState(false);
  useEffect(() => {
    fetchData();
  }, [
    page,
    sortState,
    availability,
    queryValue,
    ts,
    // startDateValue,
    // endDateValue,
    selectedCategory,
    selectedSorting,
  ]);

  async function fetchData() {
    let responseCategories = "";
    let responseStatuses = "";
    let responseContacts = "";
    if (categories.length === 1)
      try {
        responseCategories = await axios.get(`/crm/categories`);
        responseCategories?.data?.data?.data &&
          setCategories((currentObjects) =>
            currentObjects.concat([
              ...responseCategories.data.data.data.map((item, index) => {
                return {
                  label: item.name,
                  value: String(item.id),
                  key: String(item.id),
                };
              }),
            ])
          );
      } catch (error) {
        console.log(error);
      }
    if (statuses.length === 1)
      try {
        responseStatuses = await axios.get(`/crm/statuses`);
        responseStatuses?.data?.data?.data &&
          setStatuses((currentObjects) =>
            currentObjects.concat([
              ...responseStatuses.data.data.data.map((item, index) => {
                return {
                  label: item.name,
                  value: String(item.id),
                  key: String(item.id),
                };
              }),
            ])
          );
      } catch (error) {
        console.log(error);
      }

    try {
      responseContacts = await axios.get(
        `/crm/contacts?per_page=${perPage}&page=${
          refBoolPage.current ? page : 1
        }${queryValue ? `&filter[global_search]=${queryValue}` : ""}${
          startDateValue && endDateValue
            ? `&filter[created_between]=${startDateValue + "," + endDateValue}`
            : ""
        }${
          selectedCategory !== "all"
            ? `&filter[category_id]=${selectedCategory}`
            : ""
        }${selectedSorting ? `&sort=${selectedSorting}` : ""}`
      );

      !responseContacts.data.data.data.length
        ? setIsListEmpty(true)
        : setIsListEmpty(false);
      setTotalPages(responseContacts.data.data.total);
      let array = [];

      for (var i = 0; i < responseContacts.data.data.data.length; i++) {
        let colorObjBgd = randomColor({
          // luminosity: "light",
          format: "rgba",
          alpha: 0.4,
        });
        // let colorObjTxt = {
        //   red: rgbToObj(colorObjBgd).red,
        //   blue: rgbToObj(colorObjBgd).blue,
        //   green: rgbToObj(colorObjBgd).green,
        //   alpha: 0.5,
        // };
        let colorObjTxt = `rgba(
            ${rgbToObj(colorObjBgd).red},
            ${rgbToObj(colorObjBgd).green},
            ${rgbToObj(colorObjBgd).blue},
            1
            
          )`;

        array.push({
          id: responseContacts.data.data.data[i].id,
          bgdColor: colorObjBgd,
          textColor: colorObjTxt,
        });
      }
      setItems(
        responseContacts.data.data.data.map((item, index) => [
          <div className="row_click" onClick={() => handleRowClick(item)}>
            <Icon
              source={item.is_favorite === 1 ? StarFilledIcon : StarIcon}
              color="warning"
            />
          </div>,
          <div
            className={
              (item?.first_name || item?.last_name) && "circle row_click"
            }
            onClick={() => handleRowClick(item)}
            style={{
              backgroundColor: array.find((x) => x.id === item.id).bgdColor,
            }}
          >
            <b
              style={{
                color: array.find((x) => x.id === item.id).textColor,
              }}
            >
              {item?.first_name || item?.last_name
                ? item?.first_name && item?.last_name
                  ? item?.first_name.toUpperCase().charAt(0) +
                    item?.last_name.toUpperCase().charAt(0)
                  : item?.first_name.toUpperCase().charAt(0) +
                    item?.first_name.toUpperCase().charAt(1)
                : ""}
            </b>
          </div>,

          <div className="row_click" onClick={() => handleRowClick(item)}>
            <Text as="p" fontWeight="bold">
              {(item?.first_name ? item?.first_name : "") +
                " " +
                (item?.last_name ? item?.last_name : "")}
            </Text>
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.note ? (
              <Tooltip content={item?.note ? item?.note : ""}>
                <Icon source={AlertCircleIcon} color="primary"></Icon>
              </Tooltip>
            ) : (
              ""
            )}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.email && item.email}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.phone && item.phone}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.company?.name && item?.company?.name && item.company.name}
          </div>,

          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.tags?.length ? (
              <div
                style={{ display: "flex", flexDirection: "row" }}
                key={item.id}
              >
                {item.tags.map((item, index) => {
                  return (
                    <div style={{ marginLeft: "7px" }} key={index}>
                      <Tag>{item}</Tag>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.internal_campaigns?.length ? (
              <div style={{ display: "flex", flexDirection: "row" }}>
                {item.internal_campaigns.map((item) => {
                  return (
                    <div style={{ marginLeft: "7px" }} key={item.id}>
                      <Badge status="info">{item.name}</Badge>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>,

          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.category && item?.category?.name && (
              <Badge status="attention">{item.category.name}</Badge>
            )}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.sectors
              ? item.sectors.map((item) => item.name).join(", ")
              : ""}
          </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.status && (
              // <Badge status="info">
              <div
                className="statusDiv"
                style={{ backgroundColor: item.status.color }}
              >
                {item?.status?.name && item.status.name}
              </div>
              // </Badge>
            )}
          </div>,
          // <div className="row_click" onClick={() => handleRowClick(item)}>
          //   {item?.note && <EllipsisText text={item?.note} length={10} />}
          // </div>,
          <div className="row_click" onClick={() => handleRowClick(item)}>
            {item?.created_at && moment(item.created_at).format(format)}
          </div>,
          <div style={{ marginRight: "1rem" }}>
            <ButtonGroup>
              <Button onClick={() => handleEdit(item.id)} loading={isSaving}>
                Edit
              </Button>
            </ButtonGroup>
          </div>,
        ])
      );
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }

  // useEffect(() => {
  //   getData();
  // }, [
  //   page,
  //   sortState,
  //   availability,
  //   queryValue,
  //   ts,
  //   startDateValue,
  //   endDateValue,
  //   selectedCategory,
  //   selectedSorting,
  // ]);
  // const getData = () => {
  //   axios
  //     .get(
  //       `/crm/contacts?per_page=${perPage}&page=${
  //         refBoolPage.current ? page : 1
  //       }${
  //         queryValue
  //           ? `&filter[${
  //               availability === "" ? "email" : availability
  //             }]=${queryValue}`
  //           : ""
  //       }${
  //         startDateValue && endDateValue
  //           ? `&filter[created_between]=${startDateValue + "," + endDateValue}`
  //           : ""
  //       }${
  //         selectedCategory !== "all"
  //           ? `&filter[category_id]=${selectedCategory}`
  //           : ""
  //       }${selectedSorting ? `&sort=${selectedSorting}` : ""}`
  //     )
  //     .then((result) => {
  //       console.log(result.data.data.data);
  //       !result.data.data.data.length
  //         ? setIsListEmpty(true)
  //         : setIsListEmpty(false);
  //       setTotalPages(result.data.data.total);
  //       let array = [];

  //       for (var i = 0; i < result.data.data.data.length; i++) {
  //         let colorObjBgd = randomColor({
  //           // luminosity: "light",
  //           format: "rgba",
  //           alpha: 0.4,
  //         });
  //         // let colorObjTxt = {
  //         //   red: rgbToObj(colorObjBgd).red,
  //         //   blue: rgbToObj(colorObjBgd).blue,
  //         //   green: rgbToObj(colorObjBgd).green,
  //         //   alpha: 0.5,
  //         // };
  //         let colorObjTxt = `rgba(
  //           ${rgbToObj(colorObjBgd).red},
  //           ${rgbToObj(colorObjBgd).green},
  //           ${rgbToObj(colorObjBgd).blue},
  //           1

  //         )`;
  //         console.log("test1=", colorObjBgd);
  //         console.log("test2=", colorObjTxt);
  //         // console.log("tessst1", rgbToObj(colorObj));
  //         // // rgbToObj(colorObj).alpha = 0;
  //         // console.log("tessst2", {
  //         //   red: rgbToObj(colorObj).red,
  //         //   blue: rgbToObj(colorObj).blue,
  //         //   green: rgbToObj(colorObj).green,
  //         //   alpha: 0.5,
  //         // });
  //         // console.log("tessst2", rgbToObj(colorObj).alpha);
  //         array.push({
  //           id: result.data.data.data[i].id,
  //           bgdColor: colorObjBgd,
  //           textColor: colorObjTxt,
  //         });
  //       }
  //       setItems(
  //         result.data.data.data.map((item, index) => [
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             <Icon
  //               source={
  //                 item.is_favorite === 1 ? StarFilledIcon : StarIcon
  //               }
  //               color="warning"
  //             />
  //           </div>,
  //           <div
  //             className="circle row_click"
  //             onClick={() => handleRowClick(item)}
  //             style={{
  //               backgroundColor: array.find((x) => x.id === item.id).bgdColor,
  //             }}
  //           >
  //             <b
  //               style={{
  //                 color: array.find((x) => x.id === item.id).textColor,
  //               }}
  //             >
  //               {item?.first_name && item?.last_name
  //                 ? item?.first_name.charAt(0) + item?.last_name.charAt(0)
  //                 : item?.first_name.charAt(0) + item?.first_name.charAt(1)}
  //             </b>
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             <Text as="p" fontWeight="bold">
  //               {item?.first_name + " " + item?.last_name}
  //             </Text>
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.email && item.email}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.company?.name && item?.company?.name && item.company.name}
  //           </div>,

  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.tags?.length ? (
  //               <div
  //                 style={{ display: "flex", flexDirection: "row" }}
  //                 key={item.id}
  //               >
  //                 {item.tags.map((item) => {
  //                   return (
  //                     <div style={{ marginLeft: "7px" }} key={item.id}>
  //                       <Tag>{item.name}</Tag>
  //                     </div>
  //                   );
  //                 })}
  //               </div>
  //             ) : (
  //               ""
  //             )}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.internal_campaign &&
  //               item?.internal_campaign?.name &&
  //               item.internal_campaign.name}
  //           </div>,

  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.category && item?.category?.name && item.category.name}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.status && item?.status?.name && item.status.name}
  //           </div>,
  //           <div className="row_click" onClick={() => handleRowClick(item)}>
  //             {item?.created_at && moment(item.created_at).format(format)}
  //           </div>,
  //           // <div style={{ marginRight: "1rem" }}>
  //           //   <ButtonGroup>
  //           //     <Button
  //           //       onClick={() => handleDelete(item.id)}
  //           //       destructive
  //           //       loading={isSaving}
  //           //     >
  //           //       Delete
  //           //     </Button>
  //           //   </ButtonGroup>
  //           // </div>,
  //         ])
  //       );
  //       setIsLoading(false);
  //     })
  //     .catch(function (error) {});
  // };
  const [sliderOpen, setSliderOpen] = useState(false);
  const [noteValue, setNoteValue] = useState("");
  const handleChangeNote = useCallback(
    (newValue) => setNoteValue(newValue),
    []
  );
  const [favoritesButtonText, setFavoritesButtonText] = useState("");
  const handleSelectChangeUserCategory = (newValue) => {
    setSelectedUserCategory(newValue);
    const bodyObj = { category_id: newValue };
    axios
      .patch(`/crm/contacts/${clickedContact.current.id}/category`, bodyObj)
      .then((result) => {
        setToastContent("The category has been changed successfully");
        toggleActive();
        setTs(+new Date());
      })
      .catch((err) => console.logs(err));
  };
  const handleSelectChangeUserStatus = (newValue) => {
    setSelectedUserStatus(newValue);
    const bodyObj = { status_id: newValue };
    axios
      .patch(`/crm/contacts/${clickedContact.current.id}/status`, bodyObj)
      .then((result) => {
        setToastContent("The status has been changed successfully");
        toggleActive();
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const dateSelectHandler = (start, end) => {};
  const cancelDateHandler = (event, picker) => {
    picker.element.val("");
    setStartDateValue("");
    setEndDateValue("");
    setTs(+new Date());
  };
  const applyDataHandler = (event, picker) => {
    picker.element.val(
      picker.startDate.format("MM/DD/YYYY") +
        " - " +
        picker.endDate.format("MM/DD/YYYY")
    );
    setStartDateValue(picker.startDate.format("YYYY/MM/DD"));
    setEndDateValue(picker.endDate.format("YYYY/MM/DD"));
    setTs(+new Date());
  };

  return (
    <Page
      fullWidth
      title="Contacts"
      secondaryActions={[
        {
          content: "Export",
          icon: ExportIcon,
          onAction: handleExport,
          loading: isExporting,
        },
        {
          content: "Categories",
          onAction: () => navigate("/admin/crm/contacts/categories"),
          // icon: CategoriesIcon,
        },
        // {
        //   content: "Tags",
        //   onAction: () => navigate("/admin/crm/tags"),
        //   // icon: CategoriesIcon,
        // },
        {
          content: "Statuses",
          onAction: () => navigate("/admin/crm/contacts/statuses"),
          // icon: CategoriesIcon,
        },
        {
          content: "Companies",
          onAction: () => navigate("/admin/crm/contacts/companies"),
          // icon: CategoriesIcon,
        },
        {
          content: "Board",
          onAction: () => navigate("/admin/crm/contacts/board"),
          // icon: CategoriesIcon,
        },
      ]}
      primaryAction={
        <Button
          variant="primary"
          onClick={() => navigate(`/admin/crm/contacts/new`)}
        >
          Add Contact
        </Button>
      }
    >
      <Card padding="0">
        {loadingMarkup}

        <div className="pt-3 ps-3 pe-3">
          <DateRangePicker
            initialSettings={{
              // autoUpdateInput: false,
              locale: {
                cancelLabel: "Clear",
              },
              startDate: "1/1/2014",
              endDate: "3/1/2014",
            }}
            onCallback={dateSelectHandler}
            onApply={applyDataHandler}
            onCancel={cancelDateHandler}
          >
            <input
              type="text"
              className="form-control col-4"
              // defaultValue={startDateValue + "-" + endDateValue}
              onChange={() => console.log("")}
              value={
                startDateValue && endDateValue
                  ? startDateValue + "-" + endDateValue
                  : ""
              }
              placeholder="Choose a date"
              // placeholder="Start Date - End Date"
            />
          </DateRangePicker>
        </div>

        <InlineGrid columns={["twoThirds", "oneThird"]} gap="200">
          <Filters
            queryValue={queryValue}
            filters={filters}
            appliedFilters={appliedFilters}
            onQueryChange={handleFiltersQueryChange}
            onQueryClear={handleQueryValueRemove}
            onClearAll={handleFiltersClearAll}
          />
          <div style={{ marginTop: "0.4rem", marginRight: "0.4rem" }}>
            <Select
              label="Filter by category:"
              labelInline
              options={categories}
              onChange={handleSelectChangeCategory}
              value={selectedCategory}
              placeholder="Please select a category"
            />
          </div>
        </InlineGrid>

        <DataTable
          columnContentTypes={["text", "text", "text", "text"]}
          headings={[
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Name
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Email
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Phone Number
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Company
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Tags
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Campaign
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Category
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Topics
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Status
            </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Note
            // </Text>,
            // <Text variant="bodyMd" as="p" fontWeight="medium">
            //   Notes
            // </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium">
              Registered at
            </Text>,
            <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
          ]}
          rows={items}
          sortable={[
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
            false,
          ]}
          defaultSortDirection="descending"
          initialSortColumnIndex={10}
          onSort={handleSort}
          verticalAlign="middle"
          stickyHeader
          // hasZebraStripingOnData
          footerContent={
            items?.length && `Showing ${items.length} of ${totalPages} results`
          }
          increasedTableDensity
        />

        {emtyState}
      </Card>
      {Math.ceil(totalPages / perPage) >= 2 && (
        <div
          style={{
            paddingTop: "10px",
            textAlign: "center",
            paddingBottom: "10px",
          }}
        >
          <Pagination
            count={Math.ceil(totalPages / perPage)}
            page={page}
            onChange={handleChangePage}
            size="large"
          />
        </div>
      )}
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={sliderOpen}
        title={
          (clickedContact?.current?.first_name
            ? clickedContact?.current?.first_name
            : "") +
          " " +
          (clickedContact?.current?.last_name
            ? clickedContact?.current?.last_name
            : "")
        }
        // from="bottom"
        // subtitle="Optional subtitle."
        onRequestClose={() => {
          setSliderOpen(false);
          if (typeof window != "undefined" && window.document) {
            document.body.style.overflow = "visible";
          }
        }}
        width="40%"
      >
        <div className="contactDetailsPanel">
          <FormLayout>
            <Text variant="headingSm" as="h6">
              USER DETAILS
            </Text>
            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Name</b>
                <p style={{ height: "0.4rem" }} />
                {!clickedContact?.current?.first_name &&
                !clickedContact?.current?.last_name
                  ? "N/A"
                  : (clickedContact?.current?.first_name
                      ? clickedContact?.current?.first_name
                      : "") +
                    " " +
                    (clickedContact?.current?.last_name
                      ? clickedContact?.current?.last_name
                      : "")}
              </div>

              <div className="columnFlex">
                <b>Email</b>
                <div style={{ height: "0.4rem" }} />{" "}
                {clickedContact.current?.email
                  ? clickedContact.current?.email
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <b>Address</b>
                <div style={{ height: "0.4rem" }} />{" "}
                {clickedContact.current?.address
                  ? clickedContact.current?.address
                  : "N/A"}
              </div>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Registered at</b>
                <div style={{ height: "0.4rem" }} />
                {clickedContact.current?.created_at
                  ? moment(clickedContact.current?.created_at).format(
                      "YYYY-MM-DD HH:mm:ss"
                    )
                  : "N/A"}
              </div>
              <div className="columnFlex">
                <div className="columnFlex">
                  <b>Campaign</b>
                  <div style={{ height: "0.4rem" }} />
                  {clickedContact.current?.internal_campaigns?.length ? (
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      {clickedContact.current.internal_campaigns.map(
                        (item, index) => {
                          return (
                            <div
                              style={{ marginLeft: index !== 0 && "7px" }}
                              key={item.id}
                            >
                              <Tag>{item.name}</Tag>
                            </div>
                          );
                        }
                      )}
                    </div>
                  ) : (
                    "N/A"
                  )}
                </div>

                {/* {clickedContact.current?.category?.name
                  ? clickedContact.current?.category?.name
                  : "N/A"} */}
              </div>
              <div className="columnFlex">
                <b>Company</b>
                <div style={{ height: "0.4rem" }} />
                {clickedContact.current?.company?.name
                  ? clickedContact.current?.company?.name
                  : "N/A"}
              </div>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Topics</b>
                <div style={{ height: "0.4rem" }} />
                {clickedContact?.current?.sectors
                  ? clickedContact.current?.sectors
                      ?.map((item) => item.name)
                      .join(", ")
                  : "N/A"}
              </div>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <div className="columnFlex">
                <b>Category</b>
                <div style={{ height: "0.4rem" }} />
                <Select
                  options={categories
                    .filter((item) => {
                      return item.value !== "all";
                    })
                    .map((element, index) => {
                      if (element.value !== "all") {
                        return element;
                      }
                      return "";
                    })}
                  // options={categories.map((element, index) => {
                  //   if (element.value !== "all") {
                  //     return element;
                  //   }
                  //   return "";
                  // })}
                  onChange={handleSelectChangeUserCategory}
                  value={selectedUserCategory}
                  placeholder="Please select"
                />
              </div>
              <div className="columnFlex">
                <b>Status</b>
                <div style={{ height: "0.4rem" }} />
                <Select
                  options={statuses
                    .filter((item) => {
                      return item.value !== "all";
                    })
                    .map((element, index) => {
                      if (element.value !== "all") {
                        return element;
                      }
                      return "";
                    })}
                  onChange={handleSelectChangeUserStatus}
                  value={selectedUserStatus}
                  placeholder="Please select"
                />
              </div>
            </FormLayout.Group>

            {clickedContact?.current?.tags?.length ? (
              <div>
                <Text variant="headingSm" as="h6">
                  TAGS
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "0.5rem",
                  }}
                >
                  {clickedContact?.current?.tags?.map((item, index) => {
                    return (
                      <div
                        style={{ marginLeft: index !== 0 && "7px" }}
                        key={index}
                      >
                        <Tag>{item}</Tag>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              ""
            )}
            <Text variant="headingSm" as="h6">
              WRITE NOTE
            </Text>
            <TextField
              value={noteValue}
              onChange={handleChangeNote}
              multiline={4}
              placeholder="Write your note here"
            />
            <div
              style={{ float: "right", cursor: "pointer" }}
              onClick={() => {
                setIsSaving(true);
                const bodyObj = { note: noteValue };
                axios
                  .patch(
                    `/crm/contacts/${clickedContact.current.id}/note/add`,
                    bodyObj
                  )
                  .then((result) => {
                    setIsSaving(false);
                    setToastContent("Your note have been added successfully");
                    toggleActive();
                    setTs(+new Date());
                  })
                  .catch((err) => console.log(err));
              }}
            >
              {!isSaving ? (
                <Icon source={SendIcon} />
              ) : (
                <Spinner size="small" />
              )}
            </div>
          </FormLayout>
        </div>
        <div className="footer mb-3">
          <FormLayout.Group>
            <Button
              variant="primary"
              fullWidth
              loading={isSaving}
              onClick={() => {
                setIsSaving(true);
                axios
                  .patch(
                    `/crm/contacts/${clickedContact.current.id}/favorites/toggle`
                  )
                  .then((result) => {
                    console.log("tesstt=", result.data.data);
                    result.data.data.is_favorite
                      ? setFavoritesButtonText("Remove from Favorites")
                      : setFavoritesButtonText("Add to Favorites");
                    setIsSaving(false);
                    setTs(+new Date());
                  })
                  .catch((err) => console.log(err));
              }}
              // icon={
              //   clickedContact.current.is_favorite
              //     ? iconStarFilled
              //     : iconStarOutlined
              // }
            >
              {favoritesButtonText}
            </Button>
            <Button
              destructive
              loading={isSaving}
              fullWidth
              // icon={DeleteMajor}
              onClick={() => {
                setSliderOpen(false);
                handleDelete(clickedContact.current.id);
              }}
            >
              Delete
            </Button>
          </FormLayout.Group>
        </div>
      </SlidingPane>
      <Modal open={popupActive} loading={true}></Modal>
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Contact"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <TextContainer>
            <p>Are you sure you want to delete this contact?</p>
          </TextContainer>
        </Modal.Section>
      </Modal>
      {toastMarkup}
    </Page>
  );

  function disambiguateLabel(key, value) {
    switch (key) {
      case "taggedWith":
        return `Tagged with ${value}`;
      case "availability":
        return `Filter by ${value}`;
      // case "productType":
      //   return value.join(", ");
      default:
        return value;
    }
  }

  function isEmpty(value) {
    if (Array.isArray(value)) {
      return value.length === 0;
    } else {
      return value === "" || value == null;
    }
  }
  function findElementByID(array, id) {
    return array.find((element) => {
      return element.id === id;
    });
  }
  function rgbToObj(rgb) {
    let colors = ["red", "green", "blue", "alpha"];

    let colorArr = rgb
      .slice(rgb.indexOf("(") + 1, rgb.indexOf(")"))
      .split(", ");

    let obj = new Object();

    colorArr.forEach((k, i) => {
      obj[colors[i]] = k;
    });

    return obj;
  }
};

export default Contacts;
